import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      maxWidth: '100%',
    },
    btn: {
      fontWeight: 500,
      textTransform: 'capitalize',
    },
  };
});

export default useStyles;
